import { useState, useEffect } from "react";
import { SessionService } from "../../services";
import "./mini-print-layout.css";
import shortid from "shortid";
import {
  formatCelular,
  formatCep,
  formatCnpj,
  formatCpf,
  formatPrice,
  formatTelefone,
} from "../../utils";
import { format } from "date-fns";

const MiniPrintLayoutFaturamento = ({ data, descricaoTipoDocumento }) => {
  const sessionService = new SessionService();
  const [empresa, setEmpresa] = useState(null);
  const [aspectRatio, setAspectRatio] = useState(0);
  const aspectLogo = (event) => {
    setAspectRatio(event.target.naturalWidth / event.target.naturalHeight);
  };
  useEffect(() => {
    const data = sessionService.getEmpresa();
    setEmpresa(data);
  }, []);

  const formatEmpresaEndereco = () => {
    const endereco = [];
    if (empresa.enderecoLogradouro) endereco.push(empresa.enderecoLogradouro);
    if (empresa.enderecoLogradouroNumero)
      endereco.push(empresa.enderecoLogradouroNumero);
    if (empresa.enderecoBairro) endereco.push(empresa.enderecoBairro);

    let cidadeEstadoEmpresa = [];
    if (empresa.enderecoCidade)
      cidadeEstadoEmpresa.push(empresa.enderecoCidade);
    if (empresa.enderecoUF) cidadeEstadoEmpresa.push(empresa.enderecoUF);
    if (cidadeEstadoEmpresa.length > 0)
      endereco.push(cidadeEstadoEmpresa.join(" - "));

    return endereco.filter(Boolean).join(", ");
  };

  const formatClienteEndereco = (endereco) => {
    if (!endereco) return null;
    const enderecoCliente = [];
    if (endereco.logradouro) enderecoCliente.push(endereco.logradouro);
    if (endereco.numero) enderecoCliente.push(endereco.numero);
    if (endereco.bairro) enderecoCliente.push(endereco.bairro);

    let cidadeEstado = [];
    if (endereco.cidade) cidadeEstado.push(endereco.cidade);
    if (endereco.estado) cidadeEstado.push(endereco.estado);
    if (cidadeEstado.length > 0) enderecoCliente.push(cidadeEstado.join(" - "));

    if (endereco.cep)
      enderecoCliente.push(`CEP: ${formatCep(String(endereco.cep))}`);

    return enderecoCliente.length > 0 ? enderecoCliente.join(", ") : null;
  };

  const formatClienteContato = (cliente) => {
    if (!cliente) return null;
    const contatos = [];
    if (cliente.telefone)
      contatos.push(`TEL: ${formatTelefone(cliente.telefone)}`);
    if (cliente.celular)
      contatos.push(`CEL: ${formatCelular(cliente.celular)}`);

    return contatos.length > 0 ? contatos.join(" ") : null;
  };

  const totalItens = parseFloat(
    data?.[
      descricaoTipoDocumento == "nf-saida" ? "totalMercadoria" : "totalItens"
    ] || 0
  );

  const totalAPagar =
    totalItens -
    parseFloat(data?.desconto || 0) +
    parseFloat(data?.acrescimo || 0) +
    parseFloat(data?.despesas || 0);

  return empresa && data ? (
    <div id="conteudo_mini">
      <div className="d-flex flex-column justify-content-center align-items-center">
        {empresa?.imagemLogo ? (
          <img
            src={empresa.imagemLogo}
            alt="Logo Empresa"
            onLoad={aspectLogo}
            style={{
              width: "100px",
              height: aspectRatio <= 1.5 ? "100px" : "20px",
              margin: "5px 0 5px",
            }}
          />
        ) : null}
        <div className="text-center">
          <h6 className="text-uppercase fw-medium">{empresa.fantasia}</h6>
          {empresa?.cnpjCpf && (
            <h6 className="text-uppercase">
              CNPJ: {formatCnpj(empresa.cnpjCpf)}
            </h6>
          )}
          <h6 className="text-uppercase">{formatEmpresaEndereco()}</h6>
        </div>
        <div className="text-center">
          <h6 className="fw-bold text-uppercase">
            {data?.numeroDocumento
              ? `${descricaoTipoDocumento ?? "Documento"} Nº ${
                  data.numeroDocumento
                }`
              : ""}
            {data?.serieDocumento ? ` Série: ${data.serieDocumento}` : ""}
            <br />
            <h6 className="text-uppercase fw-medium">
              {data?.dataEmissao
                ? format(
                    new Date(Date.parse(data.dataEmissao)),
                    "dd/MM/yyyy HH:MM"
                  )
                : ""}
            </h6>
          </h6>
        </div>
        {Object.keys(data?.cliente ?? {}).length > 0 ? (
          <div className="text-center">
            <br />
            <h6 className="fw-bold text-center text-uppercase">
              Dados do Cliente
            </h6>
            <div className="m-1 text-center">
              {data.cliente?.nomeRazaoSocial && (
                <h6 className="fw-medium">{data.cliente?.nomeRazaoSocial}</h6>
              )}
              {data.cliente?.cnpjCpf && (
                <h6 className="text-uppercase">
                  {data.cliente?.naturezaSocial === "fisica"
                    ? `CPF: ${formatCpf(data.cliente?.cnpjCpf)}`
                    : `CNPJ: ${formatCnpj(data.cliente?.cnpjCpf)}`}
                </h6>
              )}
              {formatClienteEndereco(data.enderecoCliente) && (
                <h6 className="text-uppercase">
                  {formatClienteEndereco(data.enderecoCliente)}
                </h6>
              )}
              {formatClienteContato(data.cliente) && (
                <h6 className="text-uppercase">
                  {formatClienteContato(data.cliente)}
                </h6>
              )}
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      <div>
        <br />
        <h6 className="fw-bold text-center text-uppercase">Produtos</h6>
        <table className="table" style={{ width: "100%" }}>
          <thead>
            <tr className="itens_border">
              <th className="texto_header" style={{ width: 10 }}>
                CÓD
              </th>
              <th className="texto_header">DESC</th>
              <th className="texto_header">QTD</th>
              <th className="texto_header">UN</th>
              <th className="texto_header">UNIT</th>
              <th className="texto_header">TOTAL</th>
            </tr>
          </thead>
          <tbody>
            {data?.[
              descricaoTipoDocumento == "nf-saida" ? "nfSaidaItens" : "itens"
            ]?.length
              ? data[
                  descricaoTipoDocumento == "nf-saida"
                    ? "nfSaidaItens"
                    : "itens"
                ].map((item) => {
                  return (
                    <>
                      <tr
                        style={{
                          border: 0,
                          borderColor: "white",
                        }}
                        key={item.id}
                      >
                        <td
                          className="itens_text"
                          style={{ width: 35, textAlign: "center" }}
                        >
                          {item.codigo}
                        </td>
                        <td
                          className="itens_text descricao_produto"
                          colSpan={5}
                        >
                          <p className="descricao_produto">
                            {item?.descricao?.length
                              ? item.descricao.substring(0, 35)
                              : ""}
                          </p>
                        </td>
                      </tr>
                      <tr className="itens_border">
                        <td className="itens_text" style={{ width: 35 }}></td>
                        <td className="itens_text" colSpan={1}></td>
                        <td className="itens_text" colSpan={1}>
                          {parseFloat(item.quantidade).toFixed(2)}
                        </td>
                        <td className="itens_text" colSpan={1}>
                          {item.unidade}
                        </td>
                        <td className="itens_text" colSpan={1}>
                          {formatPrice(
                            item[
                              descricaoTipoDocumento == "nf-saida"
                                ? "valor"
                                : "valorUnitario"
                            ]
                          )}
                        </td>
                        <td className="itens_text" colSpan={1}>
                          {formatPrice(
                            item[
                              descricaoTipoDocumento == "nf-saida"
                                ? "subtotal"
                                : "totalItem"
                            ]
                          )}
                        </td>
                      </tr>
                    </>
                  );
                })
              : null}
          </tbody>
        </table>
      </div>
      <div style={{ width: "100%", padding: "0.5rem 0rem" }}>
        <div className="list_valores">
          <h6>QTD. TOTAL DE ITENS</h6>
          <h6 className="valor_list">
            {
              data?.[
                descricaoTipoDocumento == "nf-saida" ? "nfSaidaItens" : "itens"
              ]?.length
            }
          </h6>
        </div>
        <div className="list_valores">
          <h6>VALOR TOTAL </h6>
          <h6 className="valor_list">
            {formatPrice(totalItens, false) ?? "0,00"}
          </h6>
        </div>
        <div className="list_valores">
          <h6>Acréscimos</h6>
          <h6 className="valor_list">
            {formatPrice(data?.acrescimo, false) ?? "0,00"}
          </h6>
        </div>
        <div className="list_valores">
          <h6>Descontos </h6>
          <h6 className="valor_list">
            - {formatPrice(data?.desconto, false) ?? "0,00"}
          </h6>
        </div>
        <div className="list_valores">
          <h6>Despesas </h6>
          <h6 className="valor_list">
            {formatPrice(data?.despesas, false) ?? "0,00"}
          </h6>
        </div>
        <div className="list_valores">
          <h6 className="fw-semibold">VALOR A PAGAR </h6>
          <h6 className="fw-semibold valor_list">
            {formatPrice(totalAPagar || 0, false) ?? "0,00"}
          </h6>
        </div>
      </div>
      {data?.[
        descricaoTipoDocumento == "nf-saida"
          ? "nfSaidaPagamentos"
          : "pagamentos"
      ]?.length ? (
        <div style={{ width: "100%", padding: "0.5rem 0.5rem" }}>
          <div className="text-center">
            <br />
            <h6 className="fw-bold text-center text-uppercase">Pagamentos</h6>
          </div>
          <div className="list_valores">
            <h6>FORMA DE PAGAMENTO</h6>
            <h6 className="valor_list">Valor Pago</h6>
          </div>
          {data[
            descricaoTipoDocumento == "nf-saida"
              ? "nfSaidaPagamentos"
              : "pagamentos"
          ].map((pag) => {
            const pagamento = data.meioPagamentoList.find(
              (meio) => meio.id === pag?.meioPagamentoId
            );
            const descricao = pagamento ? pagamento.descricao : "";
            return (
              <div className="list_valores" key={shortid.generate()}>
                <h6>{descricao}</h6>
                <h6 className="valor_list">
                  {formatPrice(pag?.valorTitulo, false)}
                </h6>
              </div>
            );
          })}
          <div className="list_valores">
            <h6>Troco </h6>
            <h6 className="valor_list">
              {formatPrice(
                totalAPagar -
                  parseFloat(
                    data?.[
                      descricaoTipoDocumento == "nf-saida"
                        ? "nfSaidaPagamentos"
                        : "pagamentos"
                    ].reduce((acumulador, objetoAtual) => {
                      return (
                        acumulador + parseFloat(objetoAtual?.valorTitulo ?? 0)
                      );
                    }, 0)
                  ),
                false
              )}
            </h6>
          </div>
        </div>
      ) : (
        <></>
      )}
      {data?.informacaoAdicional && (
        <div className="text-center">
          <br />
          <h6 className="fw-bold text-center text-uppercase">Observações</h6>
          <h6>{data.informacaoAdicional || data.informacoesAdicionais}</h6>
        </div>
      )}
      <div>
        <br />
        <table className="table">
          <thead>
            <tr className="itens_border">
              <th className="texto_header"></th>
            </tr>
          </thead>
          <tbody>
            <div className="text-center pb-3">
              <h6 className="fw-bold text-center text-uppercase">
                Assinatura do Cliente
              </h6>
            </div>
          </tbody>
        </table>
      </div>
      {data?.status === "CANCELADA" && (
        <span className="danfe_cancelada">CANCELADA</span>
      )}
    </div>
  ) : (
    <div></div>
  );
};
export default MiniPrintLayoutFaturamento;
